import React from 'react'
import PropTypes from 'prop-types';
import PreparingPapersGenerator from "./PreparingPapersGenerator";


function Index(
    {
        expanded
    }) {
    return expanded && <PreparingPapersGenerator/>
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;